<template>
  <section class="brief-step">
    <div class="brief-step__container">
      <div class="uk-container">
        <p class="page-section__title">
          brief
          <span class="page-section__title-tooltip">kto pyta nie błądzi</span>
        </p>
        <h2 class="brief-step__title">
          {{ title }}
          <Tooltip v-if="tooltip" :title="tooltip" />
        </h2>
        <slot name="content" />
      </div>
    </div>
  </section>
</template>
<script>
import Tooltip from './tooltip.vue';

export default {
  name: 'BriefStep',
  components: { Tooltip },
  props: {
    title: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      required: false,
    },
  },
};
</script>
<style scoped lang="scss">
.brief-step {
  flex-grow: 1;
  background-color: $gray;
  padding: rem(110px 0 0);
  display: flex;
  flex-direction: column;
  margin: 0;
  border: none;

  @include media-min($lg) {
    padding-top: rem(150px);
  }

  .page-section__title-tooltip {
    top: rem(-18px);
    left: unset;
    margin-left: rem(17px);
    position: relative;
  }

  .form-input {
    width: 100%;
  }

  &__title {
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1.875rem;
    margin-bottom: rem(48px);
  }

  &__container {
    flex-grow: 1;
    position: relative;
    padding-bottom: rem(100px);

    @include media-min($lg) {
      padding-bottom: rem(50px);
    }

    .form__label {
      text-transform: unset;
    }
  }

  &__dynamic-content {
    border-bottom: rem(1px) solid #e7e7e7;
    padding-bottom: 1.25rem;
    margin-bottom: 1rem;

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
      margin-bottom: rem(1.25rem);
    }
  }

  &__add-item-wrapper {
    padding-top: rem(17px);
    border-top: rem(1px) solid #e7e7e7;
  }

  &__add-item {
    border: none;
    background-color: transparent;
    margin: 0;
    padding: 0;
    transition: $t-color;

    &:hover {
      color: $link;
    }
  }

  &__skip-step {
    margin-top: rem(40px);

    @include media-min($md) {
      margin-top: rem(50px);
    }
  }

  .uk-container {
    @include media-min($lg) {
      max-width: rem(780px);
    }
  }
}
</style>
